import * as React from 'react';

export function LoadingScreen() {
  return(<div className="flex flex-col items-center justify-center loader-container">
      <div className="loader"></div>
  </div>);
}
